import { render, staticRenderFns } from "./notification-center-view.vue?vue&type=template&id=b8748de6&scoped=true"
import script from "./notification-center-view.vue?vue&type=script&lang=js"
export * from "./notification-center-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8748de6",
  null
  
)

export default component.exports